import { Badge } from 'react-bootstrap';

/**
 * The tools-panel badge for a shape outside the authorized area. The visible text is short; a
 * screen reader reads the full sentence.
 *
 * @param {Object} props
 * @param {string} props.shapeLabel The shape name, such as `Polygon 1`.
 * @returns {JSX.Element}
 */
const OutsideAreaBadge = ({ shapeLabel }) => (
  <Badge bg="danger" className="flex-shrink-0">
    <span aria-hidden="true">Outside area</span>
    <span className="visually-hidden">{`${shapeLabel} is outside the authorized area`}</span>
  </Badge>
);

export default OutsideAreaBadge;
